import type { ICampaign } from "../../../../types/models/campaign.models.types";
import { useGetHttp } from "../../http.hook";

interface IResponse {
  campaign: ICampaign;
}

export function useGetCampaignByIdAdminHttp() {
  return useGetHttp<IResponse>({
    path: "/admin/campaigns/:id",
  });
}
